export {
  PartnershipsFeature as default,
  getStaticProps,
} from '@cinch-nx/landing-feature-partnerships'
